export default {
  name: "Users",
  path: "/users",
  component: () => import("@/views/Users")
};
